const React = require('react');
const Ripple = require('../Ripple');


module.exports = (props) => {
  return (
    <Ripple
      {...props}
      className={`layoutRow fhaC fvaC bg5B47FF h45 wmin140 r9 cF ttU ov dn
        f16 lts0em fw4 tc ph15 bg4B37EF:not[.disabled]:h bgA3A7AC.disabled `
        + (props.className || '')}
    />
  );
};
